/* @flow */

import React from 'react';
import styled from 'styled-components';

import Menu from './Menu';
import Canvas from './Canvas';
import WorldInfo from './WorldInfo';
import GlobalManager from './GlobalManager';
import { MessageTop, MessageCenter } from './Message';

const Container = styled.div`
  width: 100%;
  height: 100%;

  text-align: center;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

type Props = {};
type State = {
  loaded: boolean,
  started: boolean,
  messageTop: Array<string>,
  messageCenter: Array<string>,
};

class App extends React.Component<Props, State> {
  level: number;
  state = {
    loaded: false,
    started: false,
    messageTop: [],
    messageCenter: [],
  };

  componentDidMount() {
    const self = this;
    GlobalManager.isReady.then(() => {
      const canvasElm = this.refs.canvas.elm;
      GlobalManager.init(canvasElm, m => this.setMessageCenter(m), m => this.setMessageTop(m));
      GlobalManager.input.subscribeMenuKeyPress('Escape', () => this.exitLevel());
      GlobalManager.input.subscribeMenuKeyPress('Backquote', () => this.onBackquote());
      GlobalManager.input.subscribeMenuKeyPress('Digit1', () => this.debugLoadWorld(1));
      GlobalManager.input.subscribeMenuKeyPress('Digit2', () => this.debugLoadWorld(2));
      GlobalManager.input.subscribeMenuKeyPress('Digit3', () => this.debugLoadWorld(3));
      GlobalManager.input.subscribeMenuKeyPress('Digit4', () => this.debugLoadWorld(4));
      self.setState({ loaded: true });
    });
  }

  exitLevel() {
    if (this.state.started) {
      this.setState({
        started: false,
      });
    }
  }
  loadLevel(levelIndex: number) {
    GlobalManager.cleanupLevel();
    this.level = levelIndex;
    const newLevel = WorldInfo.loadLevelByIndex(() => this.onComplete(), this.level);
    this.setState({
      started: !!newLevel,
    });
  }
  clickLevel(levelKey: string) {
    const levelIndex = WorldInfo.lookupLevelIndexForKey(levelKey);
    this.loadLevel(levelIndex);
  }
  onComplete() {
    // ignore duplicate commands from zombie levels running the in background
    if (this.state.started) {
      this.loadLevel(this.level + 1);
    }
  }
  onBackquote() {
    if (this.state.started) {
      this.onComplete();
    } else {
      this.debugLoadWorld(0);
    }
  }
  debugLoadWorld(worldIndex: number) {
    // ignore these commands outside of the menu
    if (!this.state.started) {
      const levelIndex = WorldInfo.lookupLevelIndexForWorld(worldIndex);
      this.loadLevel(levelIndex);
    }
  }

  setMessageTop(message: Array<string>) {
    if (message.join('|') !== this.state.messageTop.join('|')) {
      this.setState({
        messageTop: message,
      });
    }
  }
  setMessageCenter(message: Array<string>) {
    if (message.join('|') !== this.state.messageCenter.join('|')) {
      this.setState({
        messageCenter: message,
      });
    }
  }
  render() {
    const { loaded, started, messageTop, messageCenter } = this.state;
    return (
      <Container>
        <Canvas ref="canvas" isVisible={started} />
        {!started && <Menu loaded={loaded} clickLevel={levelKey => this.clickLevel(levelKey)} />}
        {messageTop && messageTop.length > 0 && <MessageTop messages={messageTop} />}
        {messageCenter && messageCenter.length > 0 && <MessageCenter messages={messageCenter} />}
      </Container>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js